import React from 'react'
import './Experience.css'
const Experience = () => {
  return (
    <div className='Experience' id='Experience'>
        <div className="achievement">
            <div className="circle">1+
            </div>
            <span >Years</span>
            <span>Experience</span>
        </div>
        <div className="achievement">
            <div className="circle" >5+
            </div>
            <span >Completed</span>
            <span>Projects</span>
        </div>
        <div className="achievement">
            <div className="circle" >1+
            </div>
            <span >Years</span>
            <span>Experience</span>
        </div>
    </div>
  )
}

export default Experience
